import React from 'react'
import PropTypes from 'prop-types'

LeadItem.propTypes = {
    item: PropTypes.object
}

function LeadItem(props) {
    const {item} = props
    const linkApp = import.meta.env.REACT_URL_IPCC || 'https://app.alohub.vn'

    return (
        <tr className="CustomersItem">
            <td className="Name">
                <a href={`${linkApp}/crm/lead/${item.leadId}`} target="_blank" rel="noreferrer">
                    {item.leadName}
                </a>
            </td>
            <td>{item.salePersonName}</td>
            <td>{item.source}</td>
            <td>{item.status}</td>
            <td>{item.lastCallStatus}</td>
        </tr>
    )
}

export default LeadItem
